export default "__VITE_ASSET__N7BDyVa$__"